import React from 'react';

import { RecommendedTrainingCoursesSettingsProps } from '../../types';

export const RecommendedTrainingCoursesSettings: React.FC<RecommendedTrainingCoursesSettingsProps> = () => {
    return <div />;
};
